/** Extrai quilometragem da secção «DADOS DO VEÍCULO» nas observações da folha de obra. */
export function extractKmFromWorkOrderObservations(observations?: string | null): string | null {
  if (!observations?.trim()) return null

  const sectionMarkers = ['=== DADOS DO VEÍCULO ===', 'DADOS DO VEÍCULO']
  let vehicleSection = observations
  for (const marker of sectionMarkers) {
    const idx = observations.indexOf(marker)
    if (idx >= 0) {
      const after = observations.slice(idx + marker.length)
      const nextSection = after.search(/===\s*[A-ZÁÉÍÓÚÃÕÇ]/)
      vehicleSection = nextSection >= 0 ? after.slice(0, nextSection) : after
      break
    }
  }

  const kmLine = vehicleSection.match(
    /(?:^|\n)\s*(?:km|quilometragem)\s*[:=]\s*([\d\s.]+)/im
  )
  if (kmLine?.[1]) {
    const digits = kmLine[1].replace(/\D/g, '')
    return digits.length > 0 ? digits : null
  }

  const loose = vehicleSection.match(/(\d[\d\s.]{2,})\s*km\b/i)
  if (loose?.[1]) {
    const digits = loose[1].replace(/\D/g, '')
    return digits.length > 0 ? digits : null
  }

  return null
}
